import HTMLPopup from "../views/components/HTMLPopup";
import ViewManager from "./ViewManager";
import { DefaultLayers } from "./Layers";
import PointerEvents from "../const/PointerEvents";
import { VendorCommandsEnum } from "../../../src/commands/VendorCommandsEnum";
import CommandManager from "../commands/CommandManager";

class HTMLPopupsManager {
    protected popups:Map<string,HTMLPopup>;
    protected container:HTMLElement;
    protected className: any;

    public init(container:HTMLElement, className?: any){
        this.container = container;
        this.className = className;
    }

    public showPopup(name:string,content:string) {
        if(!this.popups){
            this.popups = new Map<string,HTMLPopup>();
        }
        if(this.popups.has(name)){
            this.closePopup(name);
        }

        let scene = ViewManager.getLayer("SplashOverlay").setScene("open");
        scene.interactive = true;

        let popup;
        if(this.className) {
            popup = new this.className(content, () => this.closePopup(name));
        } else {
            popup = new HTMLPopup(content);
            scene.on(PointerEvents.DOWN,()=>{
                this.closePopup(name);
            });
        }
        this.container.appendChild(popup.content);
        this.popups.set(name,popup);
    }

    public closePopup(name:string){
        if(!this.popups){
           return;
        }
        if(this.popups.has(name)){
            this.container.removeChild(this.popups.get(name).content);
            this.popups.delete(name);
            ViewManager.getLayer("SplashOverlay").clear();

        }

        CommandManager.execute(VendorCommandsEnum.GAME_PAUSED, false);
    }
}

export default new HTMLPopupsManager();